<template>
    <span>
        <span v-if="internalValue">{{ formatDate(internalValue) }}</span>
        <span v-if="!internalValue">-</span>
    </span>
</template>

<script>
    export default {
        name: 'Date',
        props: ['value','label','name','placeholder','useLocalTz'],
        data: function () {
            return {
                internalValue: '',
                localTz: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.localTz = this.useLocalTz ? true : false;
        },
        methods: {
            formatDate: function(value){

                if( this.localTz )
                {
                    return moment(this.internalValue).tz('Europe/Zurich').format('DD.MM.YYYY');
                }

                return moment(this.internalValue).format('DD.MM.YYYY');

            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Date.vue